<template>
  <f-container class="py-4">
    <f-row class="justify-content-center align-items-center text-center text-white">
      <f-col
          sm="12"
          md="12"
          lg="5"
          xl="5">
        <f-headline tag="h5" class="mb-3">
          Finde jetzt das richtige Auto Abo für dich
        </f-headline>
        <ul class="p-0 d-none d-lg-block">
          <li class="d-inline mr-2">1. Auto suchen</li>
          <li class="d-inline mr-2">2. Buchen</li>
          <li class="d-inline mr-2">3. Flexibel fahren</li>
        </ul>
      </f-col>
      <f-col
          sm="12"
          md="12"
          lg="auto"
          xl="auto"
      >
        <div class="col-lg-auto text-center px-lg-3 text-center">
          <f-button :to="catalogUrl" variant="primary" size="lg" class="mb-3">
            Auto finden
          </f-button>
          <label class="d-none d-lg-block pt-2"><small>ohne Anmeldung</small></label>
          <ul class="p-0 d-block d-lg-none">
            <li class="d-inline mr-2">1. Auto suchen</li>
            <li class="d-inline mr-2">2. Buchen</li>
            <li class="d-inline mr-2">3. Flexibel fahren</li>
          </ul>
        </div>
      </f-col>
    </f-row>
  </f-container>

</template>

<script>
export default {
  name: "CTA-Bar",
  props: ['linkUrl', 'catalogUrl'],
}
</script>

<style scoped>

</style>
